import { z } from 'zod';
import { idSchema } from './common.js';
/**
 * Anexos: a nota em PDF, a proposta do fornecedor, o comprovante do PIX.
 *
 * O papel que hoje vive no WhatsApp de alguém. Fica pendurado numa entidade
 * (documento fiscal, lançamento, pedido, pessoa, recebimento) — nunca
 * solto, senão vira pasta de arquivos que ninguém acha depois.
 */
export const ATTACHMENT_ENTITIES = [
    'FiscalDocument',
    'FinancialEntry',
    'PurchaseOrder',
    'PurchaseRequisition',
    'SupplierQuote',
    'Person',
    'Receiving',
    'ReceivingItem',
    'ReceivingDivergence',
];
export const attachmentEntitySchema = z.enum(ATTACHMENT_ENTITIES);
export const ATTACHMENT_ENTITY_LABELS = {
    FiscalDocument: 'Documento fiscal',
    FinancialEntry: 'Lançamento financeiro',
    PurchaseOrder: 'Pedido de compra',
    PurchaseRequisition: 'Requisição de compra',
    SupplierQuote: 'Proposta de fornecedor',
    Person: 'Pessoa',
    Receiving: 'Recebimento',
    ReceivingItem: 'Item do recebimento',
    ReceivingDivergence: 'Divergência do recebimento',
};
/**
 * Tipos aceitos. Nada de executável nem de compactado: anexo é para OLHAR,
 * e um .zip esconde o que está entrando no servidor.
 */
export const ATTACHMENT_MIME_TYPES = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'image/webp',
    'text/xml',
    'application/xml',
];
export const attachmentSchema = z.object({
    id: idSchema,
    entity: attachmentEntitySchema,
    entityId: idSchema,
    filename: z.string(),
    mimeType: z.string(),
    sizeBytes: z.number().int(),
    createdAt: z.string(),
    createdById: idSchema.nullable(),
    createdByName: z.string().nullable(),
});
export const attachmentListQuerySchema = z.object({
    entity: attachmentEntitySchema,
    entityId: idSchema,
});
/** Legível para gente: "2,4 MB" em vez de 2516582. */
export function formatBytes(bytes) {
    if (bytes < 1024)
        return `${bytes} B`;
    if (bytes < 1024 * 1024)
        return `${Math.round(bytes / 1024)} KB`;
    return `${(bytes / (1024 * 1024)).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} MB`;
}
//# sourceMappingURL=attachment.js.map